var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"SiteAside-container"},[_c('Avatar',{attrs:{"url":"https://picsum.photos/300/300","size":180}}),_c('h1',[_vm._v("阿博")]),_c('Menu'),_c('Contact')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }